<template>
    <div class="table-wrapper">
      <div class="table-actions">
        <div class="search-container">
          <Input
            :modelValue="search"
            @update:modelValue="handleSearchChange"
            legend="Pesquisar"
            placeholder="Busque por nome ou CPF..."
            :disabled="loading"
          />
        </div>
      </div>
  
      <div v-if="loading" class="loading-container">
        <LoadingSpinner :size="60" />
      </div>
  
      <div v-else class="table-responsive">
        <Table :headers="tableHeaders">
          <tr v-for="aluno in alunos" :key="aluno.id">
            <td>{{ aluno.aluno.nome }}</td>
            <td>{{ aluno.aluno.cpf }}</td>
          </tr>
          
          <tr v-if="alunos.length === 0">
            <td :colspan="tableHeaders.length" class="text-center">
              Nenhum registro encontrado.
            </td>
          </tr>
        </Table>
  
        <div class="pagination-container">
          <Paginate
            :total-pages="paginationData.lastPage"
            :current-page="paginationData.currentPage"
            @page-changed="fetchAlunos"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import * as spinners from 'epic-spinners'
  import urlApi from '../../../router/urlApi'
  import Table from 'core/Table'
  import Input from 'core/Input'
  import Paginate from 'core/Paginate'
  import IconButton from 'core/IconButton'
  import LoadingSpinner from 'core/LoadingSpinner'
  import AccountOutline from 'icons/AccountOutline'
  import { debounce } from 'lodash'
  
  export default {
    name: 'TableAlunosRegulares',
    components: {
      ...spinners,
      Table,
      Input,
      Paginate,
      IconButton,
      LoadingSpinner,
      AccountOutline
    },
    props: {
      idTurma: {
        type: [String, Number],
        required: true
      },
      virtual: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        search: '',
        alunos: [],
        loading: false,
        tableHeaders: ['Nome', 'CPF'],
        paginationData: {
          currentPage: 1,
          lastPage: 1,
          total: 0
        }
      }
    },
    mounted() {
      this.fetchAlunos(1)
    },
    methods: {
      async fetchAlunos(page = 1) {
        this.loading = true
        try {
          const response = await this.$http.get(`${urlApi}/alunos/paginacao/${this.idTurma}`, {
            params: {
              page: page,
              search: this.search
            }
          })
          
          const responseData = response.data
          this.alunos = responseData.data
          
          this.paginationData = {
            currentPage: responseData.current_page,
            lastPage: responseData.last_page,
            total: responseData.total
          }
        } catch (error) {
          this.toast('Erro ao carregar os alunos')
          console.error('Erro ao buscar alunos:', error)
        } finally {
          this.loading = false
        }
      },
        handleSearchChange: debounce(function(value) {
            this.search = value
            if (!this._allAlunos) {
                this._allAlunos = [...this.alunos]
            }
            if (!value) {
                this.alunos = [...this._allAlunos]
            } else {
                const searchLower = value.toLowerCase()
                this.alunos = this._allAlunos.filter(aluno => {
                const nome = aluno.aluno.nome ? aluno.aluno.nome.toLowerCase() : ''
                const cpf = aluno.aluno.cpf ? aluno.aluno.cpf.toLowerCase() : ''
                return nome.includes(searchLower) || cpf.includes(searchLower)
                })
            }
        }, 500),
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .table-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .table-actions {
    display: flex;
    justify-content: flex-end;
    
    .search-container {
      width: 300px;
    }
  }
  
  .loading-container {
    display: flex;
    justify-content: center;
    padding: 2rem 0;
  }
  
  .pagination-container {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
  }
  
  .actions {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
  }
  
  .text-center {
    text-align: center;
  }
  </style>
  